import React from 'react';
import ReactDOM from 'react-dom';
import { translate } from 'react-i18next';

import ExchangePopoverItem from 'components/ExchangePopoverItem.js';
import ScheduleCounterTab from 'components/ScheduleCounterTab.js';
import Popover from 'components/popover/Popover.js';

class ScheduleExchangeShiftsCounter extends ScheduleCounterTab {
  constructor(props) {
    super(props);

    this._onCloseMyPopover = this._onCloseMyPopover.bind(this);
    this._onHandleClosePopover = this._onHandleClosePopover.bind(this);
    this._onExchangesLoaded = this._onExchangesLoaded.bind(this);
    this._onExchangePostSuccess = this._onExchangePostSuccess.bind(this);
    this._onAllShiftsLoaded = this._onAllShiftsLoaded.bind(this);
    this.dataErrorHandler = this.dataErrorHandler.bind(this);
    this._onBidsAdded = this._onBidsAdded.bind(this);
    this._onBidsRemoved = this._onBidsRemoved.bind(this);
  }

  componentDidMount() {
    // TODO: not sure if any of these are needed if the contents of the counter and list are governed via props
    ShiftStore.on('all:shifts:load:success', this._onAllShiftsLoaded, this);
    ExchangesStore.on('exchanges:load:error', this.dataErrorHandler, this);
    ExchangesStore.on('exchanges:post:advertisment:success', this._onExchangePostSuccess, this);
    ExchangesStore.on('exchanges:cancel:advertisment:success', this._onExchangePostSuccess, this);
    ExchangesStore.on('all:exchanges:load:success', this._onExchangesLoaded, this);
    BidsStore.on('exchanges:post:bids:success', this._onBidsAdded, this);
    BidsStore.on('exchanges:post:bid:drop:success', this._onBidsAdded, this);
    BidsStore.on('bids:destroy:success', this._onBidsRemoved, this);
    document.addEventListener('popover:closed', this._onHandleClosePopover, this);

    Utils.initializeTabs();

    this.state = {
      notificationData: [],
      shiftData: [],
      exchanges: [],
      myExchanges: [],
      popOverActive: false,
      popTarget: null,
      notificationCount: 0,
    };
  }

  _onAllShiftsLoaded(response) {
    this.parseExchangeData();
  }

  _onExchangePostSuccess(collection, response) {
    this.parseExchangeData();
  }

  _onExchangesLoaded(response) {
    this.parseExchangeData();
  }

  _onBidsAdded(store, collection) {
    this.parseExchangeData();
  }

  _onBidsRemoved(store, collection) {
    this.parseExchangeData();
  }

  componentWillUnmount() {
    ShiftStore.off('all:shifts:load:success', this._onAllShiftsLoaded, this);
    ExchangesStore.off('exchanges:post:advertisment:success', this._onExchangePostSuccess, this);
    ExchangesStore.off('exchanges:cancel:advertisment:success', this._onExchangePostSuccess, this);
    ExchangesStore.off('exchanges:load:error', this.dataErrorHandler, this);
    ExchangesStore.off('all:exchanges:load:success', this._onExchangesLoaded, this);
    BidsStore.off('exchanges:post:bids:success', this._onBidsAdded, this);
    BidsStore.off('bids:destroy:success', this._onBidsRemoved, this);
    document.removeEventListener('popover:closed', this._onHandleClosePopover, this);
  }

  _onHandleClosePopover(e) {
    if (ReactDOM.findDOMNode(this).contains(e.popOver)) {
      this._onCloseMyPopover();
    }
  }

  _onCloseMyPopover() {
    if (this.state.popOverActive) {
      this.setState({
        popOverActive: false,
        popTarget: null,
      });
    }
  }

  parseExchangeData() {
    const exchanges = [];
    const myExchanges = [];

    const shiftData = ShiftStore.getAllShiftsUntilTheEndOfTime();
    const notificationData = ExchangesStore.getAllExchangesUntilTheEndOfTime();

    if (!Utils.isNotDefined(notificationData) && !Utils.isNotDefined(shiftData)) {
      // TODO - extract this to cleaner, more maintainable methods.
      // Probably in another component entirely since this one's responsibility should be to display a list
      // not to filter it's contents.
      var notificationCount = notificationData.length;
      const shiftCount = shiftData.length;
      for (let i = 0; i < notificationCount; i++) {
        const data = notificationData[i];
        const exchange = ExchangesStore.getAllExchangeByShiftId(data.shift_id);
        const drop = !Utils.isNotDefined(exchange) ? exchange.drop : exchange.drop;
        const bids = !Utils.isNotDefined(exchange)
          ? exchange.bids
          : !Utils.isNotDefined(exchange.bids)
            ? exchange.bids
            : [];
        if (bids.length > 0) {
          for (var x = 0; x < bids.length; x++) {
            const bid = ExchangesStore.getAllBidsById(bids[x]);
            if (
              bid
              && bid.user_id == Utils.getCoreUser().id
              && !Utils.isNotDefined(data.shift_details)
            ) {
              const startTime = moment(data.shift_details.start_time)
                .tz(data.shift_details.time_zone)
                .format('h:mm a');
              const endTime = moment(data.shift_details.end_time)
                .tz(data.shift_details.time_zone)
                .format('h:mm a');
              const hideEnd = data.shift_details.hide_end_time;
              const momentObj = moment(data.shift_details.start_time).tz(data.shift_details.time_zone);
              const selectDate = momentObj.format('YYYY-MM-DD');
              const shiftDate = Utils.formatLocaleDate(momentObj);

              let exchangeTitle = this.props.t('ScheduleExchangeShiftsCounter.drop_offer');
              if (!drop) {
                exchangeTitle = this.props.t('ScheduleExchangeShiftsCounter.exchange_offer');
              }
              const viewOffers = this.props.t('ScheduleExchangeShiftsCounter.view_details');
              exchanges.push(
                <ExchangePopoverItem
                  key={_.uniqueId()}
                  title={exchangeTitle}
                  selectDate={selectDate}
                  shiftDate={shiftDate}
                  startTime={startTime}
                  endTime={!hideEnd ? endTime : this.props.t('ScheduleExchangeShiftsCounter.tbd')}
                  shift_id={exchange.shift_id}
                  viewOffers={viewOffers}
                  state={data.state == 'new' ? null : this.props.t('ScheduleExchangeShiftsCounter.accepted')}
                  clickHandler={e => this.onClickHandler(e)}
                />,
              );

              exchanges.sort(
                (a, b) => parseFloat(moment(a.props.shiftDate, 'ddd MMM D, YYYY').unix())
                  - parseFloat(moment(b.props.shiftDate, 'ddd MMM D, YYYY').unix()),
              );

              break;
            }
          }
        } else {
          const acceptedExchanges = typeof data.shift_details !== 'undefined' ? data.shift_details.exchanges : [];
          if (acceptedExchanges.length > 0) {
            for (var x = 0; x < acceptedExchanges.length; x++) {
              const acceptedUser = !Utils.isNotDefined(acceptedExchanges[x].accepted_user_id)
                ? acceptedExchanges[x].accepted_user_id
                : null;
              if (acceptedUser == Utils.getCoreUser().id) {
                const startTime = moment(data.shift_details.start_time)
                  .tz(data.shift_details.time_zone)
                  .format('h:mm a');
                const endTime = moment(data.shift_details.end_time)
                  .tz(data.shift_details.time_zone)
                  .format('h:mm a');
                const hideEnd = data.shift_details.hide_end_time;
                const momentObj = moment(data.shift_details.start_time).tz(data.shift_details.time_zone);
                const selectDate = momentObj.format('YYYY-MM-DD');
                const shiftDate = Utils.formatLocaleDate(momentObj);

                let exchangeTitle = this.props.t('ScheduleExchangeShiftsCounter.drop_offer');
                if (!drop) {
                  exchangeTitle = this.props.t('ScheduleExchangeShiftsCounter.exchange_offer');
                }
                const viewOffers = this.props.t('ScheduleExchangeShiftsCounter.view_details');
                exchanges.push(
                  <ExchangePopoverItem
                    key={_.uniqueId()}
                    title={exchangeTitle}
                    selectDate={selectDate}
                    shiftDate={shiftDate}
                    startTime={startTime}
                    endTime={!hideEnd ? endTime : this.props.t('ScheduleExchangeShiftsCounter.tbd')}
                    shift_id={exchange.shift_id}
                    viewOffers={viewOffers}
                    state={data.state == 'accepted' ? this.props.t('ScheduleExchangeShiftsCounter.pending_approval') : null}
                    clickHandler={e => this.onClickHandler(e)}
                  />,
                );
                exchanges.sort(
                  (a, b) => parseFloat(moment(a.props.shiftDate, 'ddd MMM D, YYYY').unix())
                    - parseFloat(moment(b.props.shiftDate, 'ddd MMM D, YYYY').unix()),
                );
              }
            }
          }
        }
      }

      for (let x = 0; x < shiftCount; x++) {
        const data = shiftData[x];
        if (data.exchanges && data.exchanges.length > 0) {
          const shiftExchanges = data.exchanges;
          for (let y = 0; y < shiftExchanges.length; y++) {
            const shiftData = shiftExchanges[y];
            if (shiftData.user_id == Utils.getCoreUser().id && shiftData.state !== 'approved') {
              const shift = ShiftStore.getAllShiftsByShiftId(shiftData.shift_id);
              if (!Utils.isNotDefined(shift) && shift) {
                const startTime = moment(shift.start_time)
                  .tz(shift.time_zone)
                  .format('h:mm a');
                const endTime = moment(shift.end_time)
                  .tz(shift.time_zone)
                  .format('h:mm a');
                const exID = shiftExchanges[y].id;
                const hideEnd = shift.hide_end_time;
                const momentObj = moment(shift.start_time).tz(shift.time_zone);
                const selectDate = momentObj.format('YYYY-MM-DD');
                const shiftDate = Utils.formatLocaleDate(momentObj);

                let shiftExchangeTitle = this.props.t('ScheduleExchangeShiftsCounter.drop');
                if (!shiftData.drop) {
                  shiftExchangeTitle = this.props.t('ScheduleExchangeShiftsCounter.exchange');
                }

                const bids = ExchangesStore.getAllBidsByExchangeID(exID);
                const viewOffers = bids && bids.length 
                  ? this.props.t('ScheduleExchangeShiftsCounter.view_offers', { count: bids.length }) 
                  : this.props.t('ScheduleExchangeShiftsCounter.view_details');

                myExchanges.push(
                  <ExchangePopoverItem
                    key={_.uniqueId()}
                    title={shiftExchangeTitle}
                    selectDate={selectDate}
                    shiftDate={shiftDate}
                    startTime={startTime}
                    endTime={!hideEnd ? endTime : this.props.t('ScheduleExchangeShiftsCounter.tbd')}
                    shift_id={shift.id}
                    viewOffers={viewOffers}
                    state={shiftExchanges[y].state === 'accepted' ? this.props.t('ScheduleExchangeShiftsCounter.pending_approval') : null}
                    clickHandler={e => this.onClickHandler(e)}
                  />,
                );
                myExchanges.sort(
                  (a, b) => parseFloat(moment(a.props.shiftDate, 'ddd MMM D, YYYY').unix())
                    - parseFloat(moment(b.props.shiftDate, 'ddd MMM D, YYYY').unix()),
                );
              }
            }
          }
        }
      }
    }

    this.setState({
      exchanges,
      myExchanges,
      notificationCount,
    });
  }

  render() {
    const countBackgroundClass = `legend-item-count ${this.props.colorProperty}`;
    const exchangeCount = _.isUndefined(this.state.exchanges) ? 0 : this.state.exchanges.length;
    const myOfferCount = _.isUndefined(this.state.exchanges) ? 0 : this.state.myExchanges.length;
    const exchangesSumCount = exchangeCount + myOfferCount;

    return (
      <div onClick={e => this._onToggleMyPopover(e)}>
        <div className="legend-item" onMouseOver={this.handleRollOver}>
          <span className="legend-item-label">{this.props.notificationLabel}</span>
          <span className={countBackgroundClass}>{exchangesSumCount}</span>
        </div>
        <Popover
          position="top"
          className="exchange-popover"
          onHide={e => this._onCloseMyPopover(e)}
          active={this.state.popOverActive}
          popTarget={this.state.popTarget}
        >
          <ul className="tabs">
            <li>
              <a
                href="#"
                data-target="tab1"
                className={exchangeCount > 0 ? 'selected' : 'disabled'}
              >
                {this.props.t('ScheduleExchangeShiftsCounter.my_posts', { count: myOfferCount })}
                <span />
              </a>
            </li>
            <li>
              <a
                href="#"
                data-target="tab2"
                className={exchangeCount === 0 ? 'disabled' : myOfferCount === 0 ? 'selected' : ''}
              >
                {this.props.t('ScheduleExchangeShiftsCounter.my_offers', { count: exchangeCount })}
                <span />
              </a>
            </li>
          </ul>
          <div className="tab-panes">
            <ul
              className={
                myOfferCount > 0
                  ? 'notificationsList tab-pane tab1 active'
                  : 'notificationsList tab-pane tab1'
              }
            >
              {this.state.myExchanges}
            </ul>
            <ul
              className={
                exchangeCount === 0
                  ? 'notificationsList tab-pane tab2'
                  : myOfferCount === 0
                    ? 'notificationsList tab-pane tab2 active'
                    : 'notificationsList tab-pane tab2'
              }
            >
              {this.state.exchanges}
            </ul>
          </div>
        </Popover>
      </div>
    );
  }
}

export default translate()(ScheduleExchangeShiftsCounter);
